import React from 'react';
import { Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ChatFavoriteButtonProps {
  isFavorite: boolean;
  onToggleFavorite: (e: React.MouseEvent) => void;
}

const ChatFavoriteButton = ({ isFavorite, onToggleFavorite }: ChatFavoriteButtonProps) => {
  return (
    <Button 
      variant="ghost" 
      size="icon" 
      onClick={onToggleFavorite}
      className="h-8 w-8" // Ensuring consistent size
    >
      <Star 
        className={cn(
          "h-4 w-4 transition-colors",
          isFavorite ? "fill-yellow-400 text-yellow-400" : "text-muted-foreground hover:text-yellow-400"
        )} 
      />
    </Button>
  );
};

export default ChatFavoriteButton;